export const clientProduction = {
    adsHeight: 100,
    adsRecommendDistance: 6000, // px of forward Recommend-feed scroll between in-feed ads
    allowAds: true, // master on/off for all ads (hides every ad placement when false)
    allowRecommendAds: false, // on/off for in-feed Recommend ads (requires allowAds)
    commentAvatarSize: 30,
    commentDescMax: 2048,
    commonBottomMinHeight: 100,
    commonMinHeight: 95,
    commonTopMinHeight: 64,
    dragDropImageSize: 1080,
    exploreLimit: 15,
    messageMax: 2000,
    postAvatarSize: 38,
    postDescMax: 2048,
    postMaxUploadSize: 26214400, // 25 * 1024 * 1024 = 25mb
    profileAvatarSize: 77,
    profileAvatarUploadSize: 512,
    profileDescMax: 1024,
    profileFilterLength: 20,
    profileImageMaxBytes: 1048576,
    profileMinHeight: 108, // px
    profilePostUploadSize: 1080,
    profileThumbnailUploadSize: 240,
    recommendLimit: 10, // posts fetched per Recommend-feed batch
    searchFilterDebounceMs: 300,
    searchLimit: 20,
    signupEmailMax: 254,
    signupMinAge: 16,
    signupPasswordMax: 128,
    signupUsernameMax: 30,
    trendingFilterDebounceMs: 300,
    trendingLimit: 20,
    userAvatarSize: 50,
    userListLimit: 10,
};
